
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import {register_api,login_api} from "../api/auth.api"
const Login = () => {
  const [useremail, setUserEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const navigate = useNavigate();
  const { user, login } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/project");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    try {
      const data = await login_api(useremail,password);
        setSuccess(true);
        login(useremail,data.userID)
        navigate("/project")
    } catch (error) {
       setError(error.message);
    }
    
  };

  const handleRegister = async () => {
    setError(null);
    setSuccess(false);
    try {
      const data = await register_api(useremail,password);
        setSuccess(true);
        login(useremail,data.userID)
        navigate("/dashboard")
    } catch (error) {
       setError(error.message);
    }
  };

  return (
    <div className="bg-white h-full flex flex-col font-['Montserrat']">
      {/* Close button for mobile */}
      <div className="lg:hidden p-4 border-b">
        <button 
          onClick={() => navigate("/")}
          className="text-gray-600 hover:text-gray-900 font-medium"
        >
          ← Back to Home
        </button>
      </div>

      {/* Login Content */}
      <div className="flex-1 flex items-center justify-center p-6 sm:p-8">
        <div className="w-full max-w-md">
          <h2 className="text-3xl font-bold text-[#0c0c1d] mb-2 text-center">Welcome Back</h2>
          <p className="text-gray-600 mb-8 text-center">Sign in to continue to MAGICS</p>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                User ID
              </label>
              <input
                type="text"
                placeholder="Enter your user ID"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff2e2e] focus:border-transparent outline-none transition-all"
                value={useremail}
                onChange={(e) => setUserEmail(e.target.value)}
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                placeholder="Enter your password"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#ff2e2e] focus:border-transparent outline-none transition-all"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="w-full bg-[#ff2e2e] text-white font-semibold py-3 rounded-lg hover:bg-[#e60000] transition-all duration-300 transform hover:scale-[1.02] shadow-lg"
            >
              Log In
            </button>

            {/* <button
              type="button"
              onClick={handleRegister}
              className="w-full bg-white text-[#ff2e2e] font-semibold py-3 rounded-lg border-2 border-[#ff2e2e] hover:bg-[#fff5f5] transition-all duration-300"
            >
              Create Account
            </button> */}
          </form>

          <p className="text-center text-sm text-gray-600 mt-6">
            By continuing, you agree to our Terms & Privacy Policy
          </p>
          {error && <p className="text-red-600 mt-2">{error}</p>}
          {success && <p className="text-green-600 mt-2">Registration successful!</p>}
        </div>
      </div>
    </div>
  );
};

export default Login;
